<template>
  <mu-list id="hcp-recent-questions">
    <mu-list-item
      class="noCursor"
      v-for="item, index in amount"
      :key="'dummy-loader-' + index"
      :title="item.display_name"
      v-if="isLoading"
    >
      <mu-linear-progress
        slot="describe" color="#d9d9d9"
        style="width: 50%; height: 14px;background: rgb(214, 214, 214); margin-bottom: 8px"
        v-bind:style="{width: getRandomArbitrary(40, 50)}"
      ></mu-linear-progress>
      <mu-avatar
        v-once
        :src="item.image"
        slot="left"
        color="white"
        backgroundColor="#E9E9E8"
      >
      </mu-avatar>
      <div slot="describe">
        <mu-linear-progress
          color="#d9d9d9"
          style="height:12px; width: 15%; background: #f1f1f1"
        ></mu-linear-progress>
      </div>
    </mu-list-item>
    <div class="item-wrap" v-for="q, index in questions" :key="`question-${index}`">
      <mu-list-item titleClass="blueTitle" :title="q.question" :describeText="`by ${q.display_name ? q.display_name : q.firstname + ' ' + q.surname}, ${date(q.timestamp)}`" disableRipple v-if="!isLoading" @click.native="goToQuestionThread(q.question_id)">
        <mu-avatar
          v-if="!q.profile_large"
          slot="left"
          color="#0179d5"
          backgroundColor="#E9E9E8">
          {{upperTwoInitials(q.display_name ? q.display_name : q.firstname + ' ' + q.surname)}}
        </mu-avatar>
        <mu-avatar
          v-if="q.profile_large"
          :src="q.profile_large"
          v-once
          slot="left"
          color="white"
          backgroundColor="#E9E9E8"
        />
        <div slot="right" class="q-stats">
          <span v-text="`${q.likes} likes`"></span>
          <span v-text="`${q.replies} replies`"></span>
        </div>
      </mu-list-item>
      <mu-divider :inset="true" v-if="index+1 !== questions.length" />
    </div>
  </mu-list>
</template>

<script type="text/javascript">

  import DiscussionApi from '../../api/Discussion';

  export default {
    name: 'hcp-forum',
    watch: {
      "$route": function() {
        let self = this;
        self.initMounted();
      }
    },
    props: {
      amount: {
        type: Number,
        required: false,
        default: 5
      }
    },
    data() {
      return {
        isLoading: true,
        questions: []
      }
    },
    methods: {
      date(date) {
        return moment(date).format("MMMM Do YYYY");
      },
      loadQuestions() {
        let self = this;
        self.isLoading = true;
        DiscussionApi.getDiscussionQuestions({
          page: 1,
          per_page: self.amount,
          type: 'HCP'
        }).then(res => {
          self.questions = res.data.questions;
          self.isLoading = false;
        })
      },
      upperTwoInitials(displayName) {
        if (displayName.indexOf(' ') !== -1) {
          const splitString = displayName.split(' ');
          return splitString[0].charAt(0).toUpperCase() + splitString[1].charAt(0).toUpperCase();
        }
        return displayName.charAt(0).toUpperCase();
      },
      getRandomArbitrary(min, max) {
        return Math.floor(Math.random() * (max - min) + min) + '%'
      },
      goToQuestionThread(id) {
        let self = this;
        self.$router.push({
          name: 'QuestionThread',
          params: {
            id: id
          }
        })
      },
      initMounted() {
        let self = this;
        self.loadQuestions();
      }
    },
    mounted() {
      let self = this;
      self.initMounted();
    }
  }

</script>

<style lang="less">
  #hcp-recent-questions {
    .mu-item-title {
      margin: 0 0 4px;
      font-weight: 500;
    }
    .mu-item-text {
      font-size: 15px;
      color: fade(#000, 60%)!important;
    }
    .mu-item-right {
      width: 70px;
      @media only screen and (max-width: 601px) {
        display: block;
        position: static;
        margin: 4px 0 0;
      }
      .q-stats {
        span {
          display: block;
        }
      }
    }
    .mu-item {
      @media only screen and (max-width: 601px) {
        display: block;
      }
    }
    .mu-item-content {
      @media only screen and (max-width: 601px) {
        display: block;
      }
    }
    .show-right {
      padding-right: 96px;
    }
  }
</style>



// WEBPACK FOOTER //
// LatestQuestions.vue?0331e54b